import { useEffect } from 'react'
import { useAuth } from '../../contexts/AuthContext'

export default function PendingApprovalPage() {
  const { user, logout } = useAuth()

  // Quietly drop the access/refresh tokens once the message is rendered.
  // The user is held here by the approval gate anyway, so the JWT serves
  // no purpose — better to invalidate it than leave it sitting in storage.
  useEffect(() => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
          Awaiting approval
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Thanks {user?.first_name || user?.display_name || 'for signing in'}. Your account
          has been created and an administrator has been notified. You'll receive an email
          as soon as your access is granted.
        </p>

        <div className="text-sm text-gray-500 dark:text-gray-400 space-y-1">
          <div><span className="font-medium">Account:</span> {user?.email}</div>
          <div className="pt-2 text-xs">You can close this window — we'll email you once access is granted.</div>
        </div>
      </div>
    </div>
  )
}
